module.exports = __webpack_public_path__ + "media/components/src/assets/images/tables/block_table_2-4c4eedf41675fd62f3fe7eae6cfc57bb.jpg";